var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roundup-row",staticStyle:{"margin-bottom":"25px"}},_vm._l((_vm.networks),function(network){return _c('ShareNetwork',{key:network.network,style:({
			backgroundColor: network.color,
			color: 'white',
			padding: '3px 5px',
			margin: '5px',
			borderRadius: '15px',
			width: '30px'
		}),attrs:{"network":network.network,"url":_vm.shareURL,"title":_vm.shareTitle,"description":_vm.shareDescription,"quote":_vm.shareQuote,"hashtags":_vm.sharing.hashtags,"twitterUser":_vm.sharing.twitterUser}},[_c('i',{class:network.icon})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }